import { render } from "./servicesComponent.vue?vue&type=template&id=0190fc8f&scoped=true"
import script from "./servicesComponent.vue?vue&type=script&lang=js"
export * from "./servicesComponent.vue?vue&type=script&lang=js"

import "./servicesComponent.vue?vue&type=style&index=0&id=0190fc8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0190fc8f"]])

export default __exports__